export default __webpack_public_path__ + "static/media/loader~iUbjUwPu.8b01397e.svg";